import $ from "jquery";
import TrackingConsent from "./TrackingConsent";

var GTMAdapter = function () {
  this.layers = [];

  // ============================================================
  this.register = function () {
    $(".js_tracking_gtag_container").each((_, el) => {
      const layerName = $(el).data("layer");
      if (window[layerName] && Array.isArray(window[layerName])) {
        if (!this.layers.includes(window[layerName])) {
          this.layers.push(window[layerName]);
        }
      }
      $(el).remove();
    });
  };

  // ============================================================
  this.pageView = function (params = {}) {
    if (!this.layers.length) return;

    TrackingConsent.setGtagConsent();

    const payload = {
      event: "page_view",
      ...params,
    };

    this.layers.forEach((layer) => layer.push(payload));
  };

  // ============================================================
  this.event = function (eventName, params = {}) {
    if (!this.layers.length) return;

    TrackingConsent.setGtagConsent();

    params.event = eventName;
    this.layers.forEach((l) => l.push(params));
  };
};

export default GTMAdapter;
